<template>
    <div class="job__status">
        <button @click="toggle" class="lc-edit-job-column pill pill--column" :class="{ 'pill--busy' : isBusy }" :aria-expanded="isOpen">
            <span v-if="isArchived" class="pill__label">Archived</span>
            <span v-else>In <span v-if="currentColumn" class="lc-job-column pill__label">{{ currentColumn.name }}</span></span>
            <icon type="chevron-bottom" color="gray" size="12" />
        </button>
        <ul v-if="channel && isOpen" class="lc-dropdown dropdown-menu" role="menu" :aria-expanded="isOpen">
            <li v-for="column in channel.columns" class="dropdown-menu__item" :class="{ 'dropdown-menu__item--active': isActive(column) }">
                <a href="#" @click.prevent="move(column)" :key="column.id" class="dropdown-menu__link" :class="`lc-column-${column.id}`">{{ column.name }}</a>
            </li>
            <li v-if="isArchived === false" class="dropdown-menu__item">
                <a href="#" @click.prevent="archive" class="lc-archive dropdown-menu__link dropdown-menu__link--danger">Archive</a>
            </li>
        </ul>
    </div>
</template>

<script>
/* global EventBus, Echo, app */
import Toggleable from '../../mixins/toggle'
import Icon from '../Global/Icon'
import { mapState } from 'vuex'

export default {
    mixins: [Toggleable],

    data () {
        return {
            isBusy: false
        }
    },

    created () {
        Echo.private(`${app.currentTenant.id}_job_${this.job.id}`)
            .listen('JobWasMoved', (e) => {
                this.$store.commit('job/SET_JOB', (e.job))
            })
    },

    methods: {
        move (column) {
            this.isBusy = true
            this.close()

            this.$nextTick(() => {
                if (this.isArchived) {
                    this.$store.dispatch('job/reinstateJob', { id: this.job.id, columnId: column.id }).then(() => {
                        this.isBusy = false
                        EventBus.$emit('newSnackbar', 'Job was reinstated')
                    })
                } else {
                    this.$store.dispatch('job/moveJob', column.id).finally(() => {
                        this.isBusy = false
                    })
                }
            })
        },

        archive () {
            if (this.isArchived) {
                return
            }

            this.$store.dispatch('channel/archiveJob', this.job).then(() => {
                window.location.href = this.channel.url
                EventBus.$emit('ArchivedJobAlert')
            })
        },

        isActive (column) {
            if (this.isArchived) {
                return false
            }

            return this.job.column_id === column.id
        }
    },

    computed: {
        ...mapState('job', ['job']),
        ...mapState('channel', ['channel']),

        isArchived () {
            return this.job.is_archived
        },

        currentColumn () {
            if (this.isArchived) {
                return null
            }

            return this.channel.columns.find(column => column.id === this.job.column_id)
        }
    },

    components: {
        Icon
    }
}
</script>
